<template>
  <div class="listing-banner-tags">
    <template v-for="tag in props.tags">
      <ui-button
        class="listing-banner-tag"
        :color-mode="UiButtonColorMode.NEUTRAL"
        :variant="UiButtonVariant.SECONDARY"
        :text="tag.text"
        @clicked="onClickTag(tag)"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
  import { UiButton, UiButtonColorMode, UiButtonVariant } from '@experience/core-button-ui';
  import type { ListingBannersButton } from '@/shared/api/experience';
  import { useBannerNavigation } from '../composables/useBannerNavigation';

  interface Props {
    tags: ListingBannersButton[];
  }

  const props = defineProps<Props>();
  const emit = defineEmits(['on-click']);

  const { handleBannerClick } = useBannerNavigation();

  const onClickTag = (tag: ListingBannersButton) => {
    emit('on-click', tag);
    handleBannerClick(tag);
  };
</script>

<style scoped lang="scss">
  .listing-banner-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
</style>
